import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class HttpFetchError extends Error {
  constructor(message) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message);
    this.name = "HttpFetchError";

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // istanbul ignore else
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpFetchError);
    }
  }
}
export class HttpResponseError extends Error {
  constructor(response, responseJson) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(response.statusText);
    _defineProperty(this, "response", void 0);
    _defineProperty(this, "responseJson", void 0);
    this.name = "HttpResponseError";

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // istanbul ignore else
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpResponseError);
    }
    this.response = response;
    this.responseJson = responseJson;
  }
}
export class HttpParseError extends Error {
  constructor(response) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(response.statusText);
    _defineProperty(this, "response", void 0);
    this.name = "HttpParseError";

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // istanbul ignore else
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpParseError);
    }
    this.response = response;
  }
}
export class HttpAbortError extends Error {
  constructor(message) {
    super(message);
    this.name = "HttpAbortError";
  }
}
//# sourceMappingURL=errors.js.map